/**
 * Created by Kristy on 24/5/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employeePurchases', {
                parent: 'adminEmployeeView',
                url: '/employeePurchases',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/purchases/purchases.html',
                controller: 'AdminEmployeeViewEmployeePurchasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
